export function getMotion(mode, motion, defaultMotions) {
  if (motion) {
    return motion;
  }

  if (defaultMotions) {
    return defaultMotions[mode] || defaultMotions.other;
  }

  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/node_modules/rc-menu/es/utils/motionUtil.js
// module id = 789
// module chunks = 0